module.exports = __webpack_public_path__ + "static/media/yoga_banner_2.3e38b71c.jpg";